import { AxiosResponse } from 'axios'
import { http } from '../../utils'
import { Response } from '../types'

export interface Activity {
  id: number
  activityByName: string
  activityTitle: string
  accountDetails: string
  activityDescription: string
  createDate: string
  isHeader: boolean
}

export interface FetchActivityResponse extends Response {
  data: Activity[]
}

export interface FetchSiteActivitiesParams {
  accountId: number
  page: number
  pageSize: number
}

export function fetchActivities(date: string) {
  let queryString = '?'
  if (date) {
    queryString += 'date=' + date
  }

  return http
    .get(`/activity/pvt${queryString}`)
    .then((response: AxiosResponse) => response)
}

export function fetchSiteActivities({
  accountId,
  page,
  pageSize,
}: FetchSiteActivitiesParams) {
  const params = new URLSearchParams()
  params.set('account_id', String(accountId))
  params.set('page', String(page))
  params.set('page_size', String(pageSize))

  return http
    .get<FetchActivityResponse>(`/activity/pvt?${params.toString()}`)
    .then((response: AxiosResponse<FetchActivityResponse>) => response.data)
}
